import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import * as ApiProxies from "./proxies";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AbpHttpInterceptor } from "@api";

@NgModule({
    imports: [CommonModule],
    providers: [
        ApiProxies.SubscriptionApi,
        ApiProxies.CustomersApi,
        ApiProxies.Customercontrollerv2Api,
        ApiProxies.OrdersApi,
        ApiProxies.MarketingApi,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
    ],
})
export class SubscriptionApiModule {}
